import { ChannelModel } from '../models/ChannelModel'

const collator = new Intl.Collator('pt-BR', {sensitivity: 'base', numeric: true})

/**
 * Ordem da listagem de canais: ativos primeiro e, dentro de cada bloco, pelo
 * canal (nome real, ex.: "Mercado Livre") e só depois pelo nome que o usuário
 * deu. Assim as contas do mesmo canal ficam juntas, independente do batismo.
 */
export function sortChannelsForList(channels: ChannelModel[]): ChannelModel[] {
    return [...channels].sort((a, b) => {
        if (a.isActive !== b.isActive) {
            return a.isActive ? -1 : 1
        }

        return collator.compare(a.getRealName(), b.getRealName())
            || collator.compare(a.name || '', b.name || '')
    })
}
